/**
 * IPD Sector reference data
 */

export const SECTORS = [
  'Agriculture & Food Security',
  'Climate & Environment',
  'Digital & Innovation',
  'Gender & Inclusion',
  'Economic Development',
];
